import { Outlet } from "react-router-dom";
import TabNavigation from "./tab";

const Setting = () => {
  return (
    <div>
      <h1 className="dashboard">
        <a href="/">
          <img src="/public/images/icon-home.svg" alt="Home" />
        </a>
        Setting
      </h1>
      <div
        className="lettergeneration-container"
        id="lettergeneration-container1"
      >
        <div
          className="tab-pane"
          role="tabpanel"
          aria-labelledby="assignmaster-tab"
        >
          <div className="content-block">
            <div className="container-fluid">
              <div className="row">
                <div className="col-lg-12">
                  <div className="bulkassign">
                    <TabNavigation />
                    <div className="tab-content mt-3">
                      <Outlet />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Setting;